import { render, staticRenderFns } from "./acquistiPolizze.vue?vue&type=template&id=67ac044e&"
import script from "./acquistiPolizze.vue.ts?vue&type=script&lang=ts&"
export * from "./acquistiPolizze.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports